import { gql } from 'apollo-angular';

export const mutationAddPwaAnalytics = gql`
mutation addPwaAnalytics ($ambassadorID: String, $key: String, $params: String ) {
    AddPwaAnalytics(ambassadorID: $ambassadorID, key: $key, params: $params )
}
`

export const mutationAddStoryAnalytics = gql`
mutation addStoryAnalytics ($ambassadorID: String, $storyID: String ) {
    AddStoryAnalytics(ambassadorID: $ambassadorID, storyID: $storyID ){
        stories {
            storyID
            created
        }
    }
}
`
